import { styled } from "@mui/material/styles";
import Typography from "@bmi-digital/components/typography";

const PREFIX = "resultsHeader";
export const classes = {
  hasBottomMargin: `${PREFIX}-bottomMargin`
};

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: "922px",
  margin: "0 auto"
});

export const ContingencyText = styled(Typography)(({ theme }) => ({
  width: "448px",
  marginTop: "18px",

  [`&.${classes.hasBottomMargin}`]: {
    marginBottom: "30px"
  },

  [theme.breakpoints.down("md")]: {
    width: "100%"
  }
}));
